module.exports = file => () => import('@/pages/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/_import_production.js